module.exports = __webpack_public_path__ + "static/media/SeloHomologacao.30dd77d9.svg";